// extracted by mini-css-extract-plugin
export default {"device-col":"LocationZonesList_device-col__hLFzI"};